import React, { useEffect, Component, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import SelectorCountry from "../../Forms/ShortCutComponents/selector_country";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { Redirect, Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "./myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../baseurl";
import InputMask from "react-input-mask";
import axios from "axios";
import CountrySelector from "../../Forms/ShortCutComponents/selector_country";
// import { Alert } from "react-bootstrap";
export default function PaymentHistoryComponent(props) {
  var companyId = localStorage.getItem("companyId");
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
  // console.log("qwe", props);
  // console.log("qwe", props.deleteOption);

  const [data, setData] = useState({
    ids: props.EditData,
    deleteOption: props.deleteOption,
    addClientP: props.addClientP,
    clientAdd: "",
    address1: "",
    address2: "",
    emails: "",
    phoneNo: "",
    // country: "",
    salesTaxNo: "",
    arrayData: [],
    sumAmount: "",
    showPaymentHistory: true,
    isLoadedTableData: false,
  });
  const [country, setCountry] = useState("");

  const toggleAddNew = (showPaymentHistory) => {
    setData({ [showPaymentHistory]: showPaymentHistory });
    console.log("showPaymentHistory", data.showPaymentHistory);
    props.toggle();
    //props.refreshAllClients();
  };
  function dueFormatorsComma(cell, row, enumObject, index) {
    let newCell = "";
    newCell = cell.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    // return newCell;
    newCell = companySymbolCurrency + " " + newCell;
    return <div>{newCell}</div>;
  }

  function dueFormatorsWithoutDiv(cell, row, enumObject, index) {
    let newCell = "";
    newCell = cell.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    // return newCell;
    newCell = companySymbolCurrency + " " + newCell;
    return newCell;
  }
  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 5,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    paginationPosition: "top",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
      },
    ],
  };
  const rowData = () => {
    return (
      <Row>
        <Col>
          <div className="row">
            <div className="col-md-12">
              <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                <div className="row">
                  <div className="col-md-12" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>
                      Client <h8 style={{ color: "tomato" }}>*</h8>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="clientAdd"
                      id="clientAdd"
                      onChange={inputEvent}
                      required
                      value={data.clientAdd}
                    />
                  </div>
                  <div className="col-md-12" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>
                      Address Line 1:
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="address1"
                      id="address1"
                      onChange={inputEvent}
                      required
                      value={data.address1}
                    />
                  </div>

                  <div className="col-md-12" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>
                      Address Line 2:
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="address2"
                      id="address2"
                      required
                      onChange={inputEvent}
                      value={data.address2}
                    />
                  </div>

                  <div className="col-md-12" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>
                      Email Address:
                      <h8 style={{ color: "tomato" }}>*</h8>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="emails"
                      id="emails"
                      required
                      onChange={inputEvent}
                      value={data.emails}
                    />
                  </div>

                  <div className="col-md-6" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>Phone Number:</Label>

                    <InputMask
                      mask="0399 9999999"
                      className="form-control"
                      name="phoneNo"
                      id="phoneNo"
                      required
                      value={data.phoneNo}
                      onChange={inputEvent}
                    />
                  </div>
                  <div className="col-md-6" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>
                      Sales Tax Number:
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="salesTaxNo"
                      required
                      id="salesTaxNo"
                      onChange={inputEvent}
                      value={data.salesTaxNo}
                    />
                  </div>
                  <div className="col-md-12" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>Country:</Label>
                    {/* <SelectorCountry
                    setselectedCountry={setselectedCountry}
                  /> */}
                    <SelectorCountry
                      countrySelect={(e) => countryHandler(e)}
                      countryId={data.country}
                    />
                  </div>
                </div>
                <hr
                  style={{
                    border: "1px solid ",
                    marginBottom: "3vh",
                    marginTop: "3vh",
                    borderColor: "E4E5E6",
                  }}
                />
                <FormGroup>
                  {props.EditData === undefined ? (
                    <>
                      <Button
                        // onClick={handleSubmitAddItem}
                        type="submit"
                        // color="success"
                        className="mr-1 invoiceSubmitButton "
                        // size="sm"
                      >
                        Save Changes
                      </Button>
                      {props.deleteOption !== 2 ? (
                        <Button
                          onClick={toggleAddNew}
                          className="mr-1"
                          size="sm"
                        >
                          Cancel
                        </Button>
                      ) : (
                        <Link to="/OverviewClient">
                          <Button className="mr-1" size="sm">
                            Cancel
                          </Button>
                        </Link>
                      )}
                    </>
                  ) : (
                    <>
                      <Button
                        type="submit"
                        size="sm"
                        color="success"
                        onClick={handleSubmitUpdateClient}
                        // className={isActive ? "hideShowDiv" : null}
                        // disabled={
                        //   this.props.location.state?.updateCheck
                        //     ? "disabled"
                        //     : ""
                        // }
                        // id="invoiceButton"
                      >
                        {/* {this.props.location.state?.updateCheck === 0
                ? "Update "
                : "Submit "} */}
                        Update
                      </Button>
                    </>
                  )}
                </FormGroup>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    );
  };
  const inputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setData({
      ...data,
      [name]: value,
    });
  };

  const countryHandler = (e) => {
    console.log(e);
    setCountry({ country: e });
  };

  useEffect(() => {
    let deleteOption = data.deleteOption;
    //toggleAddNew();
    getById();
    // if (deleteOption === 1) {
    //   //0 for edit //1 delete and 2 for add
    //   console.log("if for delete");
    //   setDelete();
    // } else if (deleteOption === 0) {
    //   console.log("else for update ");
    //   getById();
    // } else {
    //   console.log("else for insert");
    // }
  }, []);

  const getById = () => {
    let pushArray = [];
    let url = "";

    if (props.invBookId === "1") {
      url = `${baseurl}/masterData/getInvoicePaymentHistory`;
    }
    if (props.invBookId === "2") {
      url = `${baseurl}/masterData/getCreditPaymentHistory`;
    }
    if (props.invBookId === "6") {
      url = `${baseurl}/masterData/getPurchasePaymentHistory`;
    }
    if (props.invBookId === "7") {
      url = `${baseurl}/masterData/getPurchaseCreditPaymentHistory`;
    }
    axios
      .post(
        `${url}`,
        {
          invoiceId: props.invoiceId,
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let sum = 0;
        console.log(res.data.data[0]);
        let resData = res.data.data;
        for (var i = 0; i < resData.length; i++) {
          sum += +res.data.data[i]["paid_amount"];
        }

        // let clientAdd = resData["COMPANY_NAME"];
        // let address1 = resData["ADDRESS1"];
        // let address2 = resData["ADDRESS2"];
        // let emails = resData["CUSTOMER_EMAIL"];
        // let phoneNo = resData["PhoneNo"];
        // let salesTaxNo = resData["SaleTaxNo"];
        // let country = resData["country"];
        // console.log(country);
        setData({
          ...data,
          sumAmount: sum,
          isLoadedTableData: true,
          arrayData: resData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmitAddItem = (event) => {
    event.preventDefault();
    var companyId = localStorage.getItem("companyId");
    var masterId = localStorage.getItem("masterId");

    console.log(country.country);

    axios
      .post(
        `${baseurl}/masterData/getAddClient`,
        {
          clientAdd: data.clientAdd,
          companyId: companyId,
          address1: data.address1,
          address2: data.address2.toString().replaceAll(",", ""),
          emails: data.emails.toString().replaceAll(",", ""),
          phoneNo: data.phoneNo,
          salesTaxNo: data.salesTaxNo,
          country: country.country?.value,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        swal({
          title: "Saved Successfully!",
          text: "Client is Added",
          icon: "success",
        }).then((value) => {
          if (data.addClientP) {
            //  window.location.reload()
            refreshForm();
          } else {
            toggleAddNew();
          }
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSubmitUpdateClient = (event) => {
    event.preventDefault();

    axios
      .post(
        `${baseurl}/masterData/updateClient`,
        {
          clientAdd: data.clientAdd,
          companyId: companyId,
          address1: data.address1,
          address2: data.address2.toString().replaceAll(",", ""),
          emails: data.emails.toString().replaceAll(",", ""),
          phoneNo: data.phoneNo,
          salesTaxNo: data.salesTaxNo,
          id: data.ids,
          country: country.country?.value,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        swal({
          title: "Saved Successfully!",
          text: "Client Updated",
          icon: "success",
        }).then((value) => {
          toggleAddNew();
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const setDelete = () => {
    let idDel = data.ids;
    var companyId = localStorage.getItem("companyId");
    let checkForDel = false;

    axios
      .post(
        // Was /invoice/getOverviewClient + a scan for INVOICE_ID, which that
        // endpoint never returns, so the check never fired. The table list
        // lives in node_backendAS/helper/partyUsageHelper.js.
        `${baseurl}/invoice/checkClientHasTransactions`,
        { username: username, companyId: companyId, custId: idDel },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (response) {
        checkForDel = response.data.hasTransactions;
        toggleAddNew();

        // return;
        if (checkForDel) {
          Swal.fire({
            title: "Cannot delete",
            text: response.data.message,
            icon: "warning",
            // showCancelButton: true,
            // confirmButtonColor: "#3085d6",
            // cancelButtonColor: "#d33",
            // confirmButtonText: "Yes, delete it!",
          });
        } else {
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          }).then((result) => {
            if (result.isConfirmed) {
              // return
              axios
                .post(
                  `${baseurl}/masterData/deleteClient`,
                  { DeleteId: idDel, username: username, companyId: companyId },
                  {
                    headers: {
                      authorization: token,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire(
                    "Deleted!",
                    "Your Record has been deleted.",
                    "success"
                  );
                  // thisContex.addToggleItem(1);
                  // props.refreshAllClients()
                })
                .catch((err) => {
                  console.log(err);
                  swal({
                    title: "Failed!",
                    // 409 from the server-side guard carries the reason.
                    text: err.response?.data?.message || "Internet Problem",
                    icon: "error",
                    button: "Try Again!",
                  });
                });
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
        swal({
          title: "Failed!",
          text: "Could not check this client's transactions.",
          icon: "error",
          button: "Try Again!",
        });
      });
  };

  const refreshForm = () => {
    setData({
      ...data,
      clientAdd: "",
      address1: "",
      address2: "",
      emails: "",
      phoneNo: "",
      country: "ggg",
      salesTaxNo: "",
    });

    setCountry({
      ...country,
      country: "",
    });
  };

  return (
    <>
      <div>
        {data.addClientP ? (
          <div>
            {console.log("eror")}
            {/* first di is ho heading design ....head bar .... */}
            <div className=" Creative-Invoice-header-styling p-3">
              <h3>Add Client</h3>
            </div>
            <div className="rowStyling p-3">{rowData()}</div>
          </div>
        ) : (
          <Modal
            show={data.showPaymentHistory}
            size="lg"
            onHide={toggleAddNew}
            backdrop="static"
          >
            {console.log("eror nhi")}
            <Modal.Header
              closeButton
              className=" Creative-Invoice-header-styling"
              onClick={() => toggleAddNew}
            >
              Payment History
            </Modal.Header>
            <Modal.Body>
              <Form name="simpleForm">
                <div className="row">
                  <div className="col-md-4" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>Invoice Date</Label>
                    <DatePicker
                      className="form-control "
                      wrapperClassName="datePicker"
                      name="clientAdd"
                      id="clientAdd"
                      dateFormat="dd-MMM-yyyy"
                      disabled={props.invoiceDate ? true : true}
                      selected={props.invoiceDate}
                    />
                  </div>
                  <div className="col-md-4" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>Invoice No:</Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="address1"
                      id="address1"
                      onChange={inputEvent}
                      disabled
                      required
                      value={props.invoiceNumber}
                    />
                  </div>
                  <div className="col-md-4" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>Customer Name</Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="address1"
                      id="address1"
                      onChange={inputEvent}
                      required
                      disabled
                      value={props.customerName}
                    />
                  </div>

                  <div className="col-md-4" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>
                      Invoice Amount{" "}
                    </Label>

                    <Input
                      type="text"
                      className="form-control"
                      name="address1"
                      disabled
                      id="address1"
                      value={
                        companySymbolCurrency +
                        " " +
                        (props.totalNet * props.convRate).toLocaleString(
                          "en-US",
                          {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }
                        )
                      }
                    />
                  </div>

                  <div className="col-md-4" style={{ marginBottom: "12px" }}>
                    <Label style={{ fontWeight: "bold" }}>Due Balance </Label>

                    <Input
                      type="text"
                      className="form-control"
                      name="address1"
                      id="address1"
                      disabled
                      value={
                        companySymbolCurrency +
                        " " +
                        (
                          props.totalNet * props.convRate -
                          data.sumAmount
                        ).toLocaleString("en-US", {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })
                      }
                    />
                  </div>
                </div>
              </Form>
              {data.isLoadedTableData ? (
                <BootstrapTable
                  data={data.arrayData}
                  striped
                  pagination
                  hover
                  // search
                  tableHeaderClass="rpr_header"
                  tableBodyClass="rpr_body"
                  containerClass="rpr_container"
                  options={options}
                >
                  {console.log("data.arrayData", data.arrayData)}
                  <TableHeaderColumn
                    dataField="date"
                    dataAlign="center"
                    // dataFormat={indexN}
                    isKey={true}
                    dataSort={true}
                    width="10%"
                  >
                    DATE PAID
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="message"
                    dataAlign="center"
                    // dataFormat={indexN}

                    dataSort={true}
                    width="10%"
                  >
                    Name
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="paid_amount"
                    dataAlign="right"
                    width="10%"
                    dataFormat={dueFormatorsComma}
                  >
                    PAID
                  </TableHeaderColumn>
                </BootstrapTable>
              ) : (
                " Loading..."
              )}
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-4"></div>

                <div className="col-md-4">
                  <div>
                    <label>Total Payment</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      style={{
                        textAlign: "right",
                        fontSize: "14px",
                      }}
                      value={dueFormatorsWithoutDiv(data.sumAmount)}
                    ></input>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
}
